import React from 'react';
import { DevelopmentSizeIcon, DevelopmentIcon, LeisureIcon, IndustrialIcon, OfficeIcon, RetailIcon, BuildingIcon } from '@domain-group/fe-co-icon';
import { PropertyType, getArea } from '@domain-group/fe-allhomes-library';
import * as styles from './commercial-feature-icons.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var Item = styles.Item,
  Icons = styles.Icons,
  Value = styles.Value;
var DEFAULT_PROPERTY_ICON = BuildingIcon;
var SIZE_ICON = DevelopmentSizeIcon;
var IconMap = {
  [PropertyType.COMMERCIAL_LAND.name]: DevelopmentIcon,
  [PropertyType.HOTEL.name]: LeisureIcon,
  [PropertyType.INDUSTRIAL.name]: IndustrialIcon,
  [PropertyType.MOTEL.name]: LeisureIcon,
  [PropertyType.OFFICE.name]: OfficeIcon,
  [PropertyType.RETAIL.name]: RetailIcon,
  [PropertyType.WAREHOUSE.name]: IndustrialIcon,
  [PropertyType.OTHER_COMMERCIAL.name]: BuildingIcon
};
var iconForType = propertyType => IconMap[propertyType === null || propertyType === void 0 ? void 0 : propertyType.name] || DEFAULT_PROPERTY_ICON;
export var CommercialFeatureIcons = _ref => {
  var propertyTypeKey = _ref.propertyType,
    _ref$additionalProper = _ref.additionalPropertyTypes,
    additionalPropertyTypeKeys = _ref$additionalProper === void 0 ? [] : _ref$additionalProper,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '' : _ref$size;
  function renderFeatureIcon(value, icon) {
    var Icon = icon;
    if (value) {
      return ___EmotionJSX(Item, null, ___EmotionJSX(Icon, {
        "data-testid": "icon",
        css: styles.itemIcon
      }), ___EmotionJSX(Value, null, value));
    }
    return null;
  }
  var propertyType = PropertyType[propertyTypeKey !== null && propertyTypeKey !== void 0 ? propertyTypeKey : 'OTHER_COMMERCIAL'];
  var area = getArea(size);
  var sizeText = size ? "Size: ".concat(area.value, " ").concat(area.unitAbbrev, " (approx)") : 'Size: n/a';
  var additionalPropertyTypes = additionalPropertyTypeKeys.map(additionalPropertyType => PropertyType[additionalPropertyType]).filter(each => each);
  return ___EmotionJSX(Icons, {
    "data-testid": "feature-icons"
  }, propertyType && renderFeatureIcon(propertyType.label, iconForType(propertyType)), additionalPropertyTypes.map(additionalPropertyType => renderFeatureIcon(additionalPropertyType.label, iconForType(additionalPropertyType))), renderFeatureIcon(sizeText, SIZE_ICON));
};